<!-- <div class="vehicle-wrapper">
  <div class="top-header">
    <h3>{{ isEditMode ? 'Edit Register' : 'Create Register' }}</h3>
    <p>Configure register details and workflow</p>
  </div>

  <form [formGroup]="registerForm" (ngSubmit)="submit()">
    <div class="container-grid">
      <div class="form-item">
        <label>Name <small>*</small></label>
        <input type="text" formControlName="name" />
        <div class="error" *ngIf="registerForm.get('name')?.invalid && registerForm.get('name')?.touched">
          <small>Name is required</small>
        </div>
      </div>
      <div class="form-item">
        <label>Description</label>
        <textarea rows="2" formControlName="description"></textarea>
      </div>
    </div>

    <div class="container-grid">
      <div class="form-item">
        <label>Scope Type <small>*</small></label>
        <select formControlName="scope_type">
          <option value="ORG">Organization</option>
          <option value="LOCATION">Location</option>
        </select>
      </div>
      <div class="form-item">
        <label>Active</label>
        <select formControlName="is_active">
          <option [ngValue]="true">Yes</option>
          <option [ngValue]="false">No</option>
        </select>
      </div>
    </div>

    <div class="container-grid" *ngIf="registerForm.value.scope_type === 'LOCATION'">
      <div class="form-item">
        <label>Location <small>*</small></label>
        <select formControlName="location">
          <option [ngValue]="null">Select</option>
          <option *ngFor="let location of locations" [ngValue]="location.id">
            {{ location.village_or_locality_name }} - {{ location.district_name }}
          </option>
        </select>
        <div class="error" *ngIf="registerForm.get('location')?.invalid && registerForm.get('location')?.touched">
          <small>Location is required</small>
        </div>
      </div>
      <div class="form-item placeholder"></div>
    </div>

    <div class="steps-section steps-header">
      <div><strong>Steps</strong></div>
      <button type="button" class="btn-action" (click)="addStep()">
        <fa-icon [icon]="['fas', 'square-plus']"></fa-icon>
        Add Step
      </button>
    </div>
    <div class="responsive-table-wrapper steps-table">
      <table>
        <thead>
          <tr>
            <th>Step</th>
            <th>Label</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let step of stepsArray.controls; let i = index" [formGroup]="step">
            <td>
              <div class="form-item">
                <input type="number" formControlName="step" readonly />
              </div>
            </td>
            <td>
              <div class="form-item">
                <input type="text" formControlName="label" />
              </div>
            </td>
            <td>
              <button type="button" class="action-button bt-delete" (click)="removeStep(i)" title="Remove Step">
                <fa-icon [icon]="['fas', 'trash']"></fa-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="checkbox-section">
      <div class="checkbox-grid">
        <div class="checkbox-item">
          <label><input type="checkbox" formControlName="workflow_enabled" /> Workflow Enabled</label>
        </div>
        <div class="checkbox-item">
          <label><input type="checkbox" formControlName="review_required" /> Review Required</label>
        </div>
        <div class="checkbox-item">
          <label><input type="checkbox" formControlName="approval_required" /> Approval Required</label>
        </div>
        <div class="checkbox-item">
          <label><input type="checkbox" formControlName="otp_required" /> OTP Required</label>
        </div>
        <div class="checkbox-item">
          <label><input type="checkbox" formControlName="qr_required" /> QR Required</label>
        </div>
        <div class="checkbox-item">
          <label><input type="checkbox" formControlName="allow_bulk_upload" /> Bulk Upload Enabled</label>
        </div>
      </div>
    </div>

    <div class="button-row button-container">
      <button type="submit" class="btn-save">
        <fa-icon [icon]="['fas', 'square-plus']"></fa-icon>
        Save
      </button>
      <button *ngIf="isEditMode" type="button" class="btn-save" (click)="goToFields()">
        Configure Fields
      </button>
      <button type="button" class="btn-cancel" (click)="cancel()">
        <fa-icon [icon]="['fas', 'square-xmark']"></fa-icon>
        Cancel
      </button>
    </div>
  </form>
</div> -->




<!-- Main Content -->
<div class="main-content">
  <div class="top-header">
    <h3>{{ isEditMode ? 'Edit Register' : 'Create Register' }}</h3>
    <p>Configure register details and workflow</p>
  </div>

  <form class="form" [formGroup]="registerForm" (ngSubmit)="submit()">
    <div class="form-row">

      <div class="form-group">
        <label>Name <small>*</small></label>
        <input type="text" placeholder="Name" formControlName="name" />
        <div class="error" *ngIf="registerForm.get('name')?.invalid && registerForm.get('name')?.touched">
          <small>Name is required</small>
        </div>
      </div>

      <div class="form-group">
        <label>Description</label>
        <input id="description" formControlName="description" placeholder="description" />
      </div>

      <div class="form-group">
        <label>Scope Type <small>*</small></label>
        <select formControlName="scope_type">
          <option value="ORG">Organization</option>
          <option value="LOCATION">Location</option>
        </select>
        <div class="error" *ngIf="registerForm.get('scope_type')?.invalid && registerForm.get('scope_type')?.touched">
          <small *ngIf="registerForm.get('scope_type')?.errors?.['required']">Scope Type is
            required.</small>
        </div>
      </div>

      <div class="form-group">
        <label>Active</label>
        <select formControlName="is_active">
          <option [ngValue]="true">Yes</option>
          <option [ngValue]="false">No</option>
        </select>
      </div>


      <div class="form-group" *ngIf="registerForm.value.scope_type === 'LOCATION'">
        <label>Location <small>*</small></label>
        <select formControlName="location">
          <option [ngValue]="null">Select Location</option>
          <option *ngFor="let location of locations" [ngValue]="location.id">
            {{ location.village_or_locality_name }} - {{ location.district_name }}
          </option>
        </select>
        <div class="error" *ngIf="registerForm.get('location')?.invalid && registerForm.get('location')?.touched">
          <small>Location is required</small>
        </div>
      </div>
      <div class="form-group placeholder"></div>



    </div>

    <div class="steps-section steps-header">
      <div><strong>Steps</strong></div>
      <button type="button" class="btn-action" (click)="addStep()">
        <fa-icon [icon]="['fas', 'square-plus']"></fa-icon>
        Add Step
      </button>
    </div>
    <div class="responsive-table-wrapper steps-table">
      <table>
        <thead>
          <tr>
            <th>Step</th>
            <th>Label</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let step of stepsArray.controls; let i = index" [formGroup]="step">
            <td>
              <div class="table-data-input">
                <input type="number" formControlName="step" readonly />
              </div>
            </td>
            <td>
              <div class="table-data-input">
                <input type="text" formControlName="label" />
              </div>
            </td>
            <td>
              <button type="button" class="action-button bt-delete" (click)="removeStep(i)" title="Remove Step">
                <fa-icon [icon]="['fas', 'trash']"></fa-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="checkbox-section">
      <div class="checkbox-grid">
        <div class="checkbox-item">
          <label><input type="checkbox" formControlName="workflow_enabled" /> Workflow Enabled</label>
        </div>
        <div class="checkbox-item">
          <label><input type="checkbox" formControlName="review_required" /> Review Required</label>
        </div>
        <div class="checkbox-item">
          <label><input type="checkbox" formControlName="approval_required" /> Approval Required</label>
        </div>
        <div class="checkbox-item">
          <label><input type="checkbox" formControlName="otp_required" /> OTP Required</label>
        </div>
        <div class="checkbox-item">
          <label><input type="checkbox" formControlName="qr_required" /> QR Required</label>
        </div>
        <div class="checkbox-item">
          <label><input type="checkbox" formControlName="allow_bulk_upload" /> Bulk Upload Enabled</label>
        </div>
      </div>
    </div>

    <div class="button-row button-container">
      <button type="submit" class="btn-save">
        <fa-icon [icon]="['fas', 'square-plus']"></fa-icon>
        Save
      </button>
      <button *ngIf="isEditMode" type="button" class="btn-save" (click)="goToFields()">
        Configure Fields
      </button>
      <button type="button" class="btn-cancel" (click)="cancel()">
        <fa-icon [icon]="['fas', 'square-xmark']"></fa-icon>
        Cancel
      </button>
    </div>
  </form>
</div>